
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'

import {formatDate} from "@/javascript/formatDate"
import Cpts020 from '@/components/lyx-components/cpts020/index.vue'
import contBox from '@/components/lyx-components/content/index.vue'
import bus from '@/javascript/bus'
import EsQuery from '@/javascript/esQuery'

export default {
components: {
Tab,
TabItem,
Actionsheet,
Cpts020,
contBox

},
data() {
return {
minHeight: '',
tabItems: [],
tabIndex: 1,
isTop: false,
Whether: false,
leftLayer: false,
rightLayer: true,
operateWay: {
save: '保存',
noSave: '不保存'
},
sendId: '',
traveList: {},
dayData: [],
dayList: [],
userId: bus.userInfo.user.id,
hotel: []
};
},
mounted() {
this.minHeight = document.documentElement.clientHeight;
/**
* 页面滚动
*/
window.addEventListener('scroll', this.windowScroll)
this.$http.get('api/wtcp-recommend/public/travelPlan/app/' + this.senId + '/' + this.userId).then((res) => {
this.traveList = res.data.data
const commentList = res.data.data.planDetail.dailyPlans
commentList.forEach((item, index) => {
item.startDate = formatDate(item.startDate, 'yyyy-MM-dd')
item.title = item.title.replace(/-/g, " ⇀ ")
item.endDate = formatDate(item.endDate, 'hh:mm')
this.getArroundData(index, item.dailySteps[item.dailySteps.length - 1].endLongitude, item.dailySteps[item.dailySteps.length - 1].endLatitude)
this.getArroundEat(index, item.dailySteps[item.dailySteps.length - 1].endLongitude, item.dailySteps[item.dailySteps.length - 1].endLatitude)
for (let i = 0; i < item.dailySteps.length; i++) {
item.dailySteps[i].endDateTime = formatDate(item.dailySteps[i].endDateTime, 'hh:mm')
item.dailySteps[i].startDateTime = formatDate(item.dailySteps[i].startDateTime, 'hh:mm')
item.dailySteps[i].distance = (item.dailySteps[i].distance) / 1000
this.$set(item.dailySteps[i], 'tetIndex', true)
if (item.dailySteps[i].stepType !== 9) {
const time = this.formatDuring(item.dailySteps[i].useTime)
item.dailySteps[i].useTime = time
} else {
item.dailySteps[i].summerTime = item.dailySteps[i].summerTime ? item.dailySteps[i].summerTime.split(',') : ''
item.dailySteps[i].winterTime = item.dailySteps[i].winterTime ? item.dailySteps[i].winterTime.split(',') : ''
item.dailySteps[i].useTime = Math.floor(item.dailySteps[i].useTime / 3600);
}
}
})
this.$set(this, 'dayData', commentList)

for (let n = 0; n < this.dayData.length; n++) {
for (let i = 0; i < this.dayData[n].dailySteps.length - 1; i++) {
if (this.dayData[n].dailySteps[i].endAddress == this.dayData[n].dailySteps[i + 1].endAddress) {
this.$set(this.dayData[n].dailySteps[i], 'summerTime', this.dayData[n].dailySteps[i + 1].summerTime);
this.$set(this.dayData[n].dailySteps[i], 'winterTime', this.dayData[n].dailySteps[i + 1].winterTime);
this.$set(this.dayData[n].dailySteps[i], 'scenicTime', this.dayData[n].dailySteps[i + 1].useTime);
this.$set(this.dayData[n].dailySteps[i], 'scenicSummary', this.dayData[n].dailySteps[i + 1].scenicSummary);
this.$set(this.dayData[n].dailySteps[i], 'titleImage', this.dayData[n].dailySteps[i + 1].titleImage);
this.$set(this.dayData[n].dailySteps[i], 'scenicId', this.dayData[n].dailySteps[i + 1].scenicId);
this.dayData[n].dailySteps.splice(i + 1, 1)
}
}
}
this.$set(this, 'dayList', this.dayData)
console.log(123456789, this.dayList)

}).then(() => {
document.title = this.traveList.title
this.onStatusChange(parseInt(this.$route.params.index), -1)
})

},
methods: {
windowScroll: function () {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
if (this.$refs.top && scrollTop >= this.$refs.top.offsetTop) {
this.isTop = true
} else {
this.isTop = false
}
},

saveTrip() {
this.Whether = true
},
xClick: function (key) {
switch (key) {
case 'save':
console.log('你点击了保存')
break;
case 'noSave':
console.log('你点击了保存')
break;
default:
break
}
},
tabHandler: function (index) {
this.$router.replace({path: this.tabItems[index].routerLink + this.senId})
},
seeMore(index, dex) {
this.dayList[index].dailySteps[dex].tetIndex = !this.dayList[index].dailySteps[dex].tetIndex
},
formatDuring(s) {
let t;
if (s > -1) {
const hour = Math.floor(s / 3600);
const min = Math.floor(s / 60) % 60;
if (hour > 0) {
t = hour + "h";
} else {
t = "";
}
t += min + "m";
}
return t;
},
onStatusChange: function (val1, val2) {
const scheduleItem = document.getElementsByClassName('schedule-item')
if (val2 === -1) {
window.scrollTo(0, scheduleItem[val1].offsetTop - 70)
} else {
if (val1 === 0) {
const noteState = scheduleItem[val1].getElementsByClassName('pice-block')
if (val2 === 0) {
let HE = 0
for (let i = 0; i <= noteState.length - 2; i++) {
HE += noteState[i].scrollHeight
}
window.scrollTo(0, HE - 25)
}
} else {
const noteState = scheduleItem[val1].getElementsByClassName('pice-block')
if (val2 === 0) {
let HE = 0
for (let i = 0; i < val2 + 1; i++) {
HE += noteState[i].scrollHeight
}
if (noteState[val2 + 2].getElementsByClassName('ticket-wrap').length !== 0) {
let tic = noteState[val2 + 2].getElementsByClassName('ticket-wrap')[0].scrollHeight
window.scrollTo(0, scheduleItem[val1].offsetTop + HE + tic + 30)
} else {
window.scrollTo(0, scheduleItem[val1].offsetTop + HE + 10)
}

} else {
let HE = 0
for (let i = 0; i <= val2 + 1; i++) {
HE += noteState[i].scrollHeight
}
window.scrollTo(0, scheduleItem[val1].offsetTop + HE + 118)
}
}
}
},
getArroundData(index, lat, long) {
const _this = this
const querystring = require('querystring');
const scenicEsQuery = new EsQuery()
scenicEsQuery
.addGeoSort("geoPoint", scenicEsQuery.asc, long, lat)
.addStartWith("region", '632523', scenicEsQuery.and, false)
.addPage(0, 2)
const scenicEsJsonQuery = JSON.stringify(scenicEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: this.INDEX_NAME_TYPE.hotel,
esJsonQuery: scenicEsJsonQuery
})).then(res => {
const data = res.data.data
this.traveList.planDetail.dailyPlans[index].hotels = data
})

},
getArroundEat(index, lat, long) {
const querystring = require('querystring');
const scenicEsQuery = new EsQuery()
scenicEsQuery
.addString("category", this.XXCJ_TYPE_CODE.CY, scenicEsQuery.and, false)
.addGeoSort("geoPoint", scenicEsQuery.asc, long, lat)
.addStartWith("region", '632523', scenicEsQuery.and, false)
.addPage(0, 2)
const scenicEsJsonQuery = JSON.stringify(scenicEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: this.INDEX_NAME_TYPE.periphery,
esJsonQuery: scenicEsJsonQuery
})).then(res => {
const data = res.data.data
this.traveList.planDetail.dailyPlans[index].foods = data
})
}
},
created() {
this.senId = this.$route.params.id
this.tabItems = [{
name: '概要',
routerLink: '/travel-profile/'
}, {
name: '详情',
routerLink: '/travel-details/0/',
}, {
name: '地图',
routerLink: '/map-days/'
},




]
}
};
